import { NgModule } from '@angular/core';
import { BaseStorefrontModule } from '@spartacus/storefront';
import { SpartacusConfigurationModule } from './spartacus-configuration.module';
import { SpartacusFeaturesModule } from './spartacus-features.module';
import { PagesModule } from '../pages/pages.module';
import { ComponentsModule } from '../components/components.module';

@NgModule({
  declarations: [],
  imports: [
    BaseStorefrontModule, 
    SpartacusFeaturesModule, 
    SpartacusConfigurationModule, 
    ComponentsModule, 
    PagesModule],
  exports: [
    BaseStorefrontModule
  ],
})
export class SpartacusModule {}
